import {combineReducers} from '@reduxjs/toolkit';

import {limitDetailsSlice} from './slices/limit-details.slice';
import {userSearchResultAccountsSlice} from './slices/user-search-result-accounts.slice';
import {userSearchResultAuditSlice} from './slices/user-search-result-audit.slice';
import {userSearchResultColumns} from './slices/user-search-result-columns.slice';
import {userSearchResultCrmIdsSlice} from './slices/user-search-result-crm-ids.slice';
import {userSearchResultGroupsSlice} from './slices/user-search-result-groups.slice';
import {userSearchResultLastActiveSlice} from './slices/user-search-result-last-active.slice';
import {userSearchResultLcdSubscriptionsSlice} from './slices/user-search-result-lcd-subscriptions.slice';
import {userSearchResultLimitsSlice} from './slices/user-search-result-limits.slice';
import {userSearchResultNewslettersSlice} from './slices/user-search-result-newsletters.slice';
import {userSearchResultSavedSearchesSlice} from './slices/user-search-result-saved-searches.slice';
import {userSearchResultStateSlice} from './slices/user-search-result-state.slice';
import {userSearchResultSlice} from './slices/user-search-result.slice';

export const userSearchResultReducer = combineReducers({
    columns: userSearchResultColumns.reducer,
    state: userSearchResultStateSlice.reducer,
    result: userSearchResultSlice.reducer,
    limitDetails: limitDetailsSlice.reducer,

    audit: userSearchResultAuditSlice.reducer,
    crmIds: userSearchResultCrmIdsSlice.reducer,
    groups: userSearchResultGroupsSlice.reducer,
    limits: userSearchResultLimitsSlice.reducer,
    accounts: userSearchResultAccountsSlice.reducer,
    lastActive: userSearchResultLastActiveSlice.reducer,
    newsletters: userSearchResultNewslettersSlice.reducer,
    lcdSubscriptions: userSearchResultLcdSubscriptionsSlice.reducer,
    savedSearches: userSearchResultSavedSearchesSlice.reducer,
});
